import { render, staticRenderFns } from "./EventViewSubsidy.vue?vue&type=template&id=c2820b58&"
import script from "./EventViewSubsidy.vue?vue&type=script&lang=js&"
export * from "./EventViewSubsidy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports